import {
  carousel_image_url,
  gallery_image,
} from '@components/blocks/images/logic';

export const property_gallery_images = (details = {}) => {
  const { photos = [] } = details;

  return photos.map((photo) => gallery_image(photo.url.standard));
};

export const room_carousel_images = (room = {}) => {
  const { photos = [] } = room;

  return photos.map(({ url }) => ({
    url: carousel_image_url(url.standard),
    thumbnail: url.thumbnail,
  }));
};
